<template>
    <div id="rightbar-right">
        <ul>
            <li class="promotion" @click="openPage(1)">
                <img loading="lazy" v-lazy="require('../../assets/images/amjs/aside_top.png')">
            </li>
            <li class="self" @click="openPage(2)">
                <img loading="lazy" v-lazy="require('../../assets/images/amjs/aside_logo1.png')">
                <span>自助中心</span>
            </li>
            <li class="service" @click="openPage(3)">
                <img loading="lazy" v-lazy="require('../../assets/images/amjs/aside_logo2.png')">
                <span>在线客服</span>
            </li>
            <li class="detection" @click="openPage(4)">
                <img loading="lazy" v-lazy="require('../../assets/images/amjs/aside_logo3.png')">
                <span>{{isAmjs ? '备用网址' : '全民代理'}}</span>
            </li>
            <li class="mobile" @click="openPage(5)">
                <img loading="lazy" v-lazy="require('../../assets/images/amjs/aside_logo4.png')">
                <span>手机下注</span>
            </li>
        </ul>
        <div class="returntotop" v-show="scrollTop > 50" @click="returnGo">
            <div>回顶部</div>
        </div>
        <!-- 福袋活动入口 -->
        <div class="lucky-bag" @click="goLucky" v-if="springShow"></div>
    </div>
</template>

<script>
export default {
    components: { },
    data() {
        return {
            floatList: [],
            scrollTop: 0,
            isAmjs: true,
            spareUrl: '',
            springShow: false, // 春节福袋显示
            springData: {}, // 春节福袋数据
        };
    },
    created() {
        this.isAmjs = window.projectImgUrl === 'amjs' ? true : false;
        this.getListFloatingWindows();
        this.getBannerSpring();
    },
    mounted() {
        let self = this;
        window.onscroll = function () {
            let num = document.documentElement.scrollTop || document.body.scrollTop;
            self.scrollTop = num;
        };
    },
    methods: {
        // 获取轮播春节活动
        getBannerSpring() {
            this.$http.get(this.$api.banner).then((res) => {
                if (res?.data.length){
                    this.springData = res.data.find(item => item?.expand?.actFolder === 'spring') || {}
                    this.springShow = Object.keys(this.springData).length > 0
                } else {
                    this.springShow = false
                }
            });
        },
        getListFloatingWindows() {
            this.$http.get(this.$api.getListFloatingWindows).then((res) => {
                if (res.code == 0) {
                    this.floatList = [...res.data];
                    this.spareUrl = this.returnSpareUrl(this.floatList);
                }
            });
        },
        returnSpareUrl(floatList) {
            for(const item of floatList) {
                if (item.fixedCode === '线路检测' || item.name === '线路检测') return item.jumpContent;
            }
        },
        returnGo() {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        openPage(type) {
            if (type === 1) {
                this.$router.push({ path: "/discount" });
            } else if (type === 2) {
                this.toNewCustomerService();
            } else if (type === 3) {
                window.open(this.$common.getCustomerService(), "_blank");
            } else if (type === 4) {
                if(this.isAmjs) {
                    window.open(this.spareUrl, "_blank");
                } else {
                    this.$router.push({ path: "/agent" });
                }
                
            } else {
                this.$router.push({ path: "/app?index=0" });
            }
        },
        toNewCustomerService() {
            //新客服
            var _this = this;
            var obj = {};
            obj.host = _this.$common.getHost();
            obj.clientCode = window.clientCode;
            obj.clientItem = window.childCode;
            obj.username = this.$common.getUser() && this.$common.getUser().username;
            obj.language = this.$common.getLocale();
            obj.theme = window.theme;
            obj.projectImgUrl = window.projectImgUrl;
            obj.orgin = window.location.origin + "/activity";
            var str = JSON.stringify(obj);
            str = window.btoa(str);
            // var url =
            //     _this.$config.customerServiceUrl +
            //     "/customerService/pc?s=" +
            //     str;
            var url = location.origin + "/func/customerService/pc?s=" + str;
            window.open(url, "_blank");
        },
        // 春节活动跳转
        goLucky() {
            if (!this.$common.getUser()) {
                this.$message.warning('请先登录！');
                return;
            }
            const obj = {
                activityId: this.springData.urlId,
                token: this.$common.getToken(),
                clientCode: window.clientCode,
                username: this.$common.getUser().username,
                language: "zh_CN",
                theme: window.theme,
                host: this.$config.baseUrl,
            };
            const str = window.btoa(JSON.stringify(obj));
            const url = window.location.origin + '/func/' + this.springData.expand.actFolder + "/pc/index.html?s=" + str;
            window.open(url);
        }
    },
};
</script>

<style lang="scss" >
#rightbar-right {
    ul {
        width: 137px;
        height: 367px;
        background-image: url('../../assets/images/amjs/aside_bg.png');
        li {
            width: 100%;
            height: 36px;
            line-height: 36px;
            margin-bottom: 13.5px;
            font-size: 16px;
            text-align: center;
            cursor: pointer;
            color: #fde9aa;
            &.promotion {
                height: auto;
                padding-top: 15px;
            }
            &:hover {
                filter: brightness(1.3);
            }
        }
    }
    // li {
    //     cursor: pointer;
    //     width: 65px;
    //     height: 65px;
    //     margin-bottom: 2px;
    //     background-repeat: no-repeat;
    //     background-position: center top;
    //     &:hover {
    //         background-position: center bottom;
    //     }
    //     &.promotion {
    //         background-image: url('../../assets/images/amjs/promotion2.png');
    //     }
    //     &.self {
    //         background-image: url('../../assets/images/amjs/self.png');
    //     }
    //     &.service {
    //         background-image: url('../../assets/images/amjs/service2.png');
    //     }
    //     &.detection {
    //         background-image: url('../../assets/images/amjs/detection.png');
    //     }
    //     &.mobile {
    //         background-image: url('../../assets/images/amjs/mobile.png');
    //     }
    // }
    .returntotop {
        width: 95px;
        height: 65px;
        margin: 0 auto;
        border-radius: 3px;
        margin-top: 30px;
        background-color: #960000;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        &:hover {
            filter: brightness(1.3);
        }
    }
    .lucky-bag {
        width: 100px;
        height: 100px;
        background-image: url('../../assets/images/amjs/lucky_bag.png');
        margin: 30px auto 0;
        cursor: pointer;
    }
}
</style>